import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, ConverterService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { SalesProductPrice } from '../../uig-product.models';

@Injectable()
export class UIGProductPriceCalculatorAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  getProductPrice(productCode: string){
    const params = {
      productCode: productCode
    }
    return this.http.get<SalesProductPrice>(
      this.occEndpoints.buildUrl('getCustomSalesPrice', {queryParams: params})
    );
  }

  updateProductPrice(
    bestPrice: string,
    productCode: string,
    userCustomUvpPrice: string,
    userCustomProfitMarginPercent: string,
    taxm1: number
  ): Observable<SalesProductPrice> {
    const params = {
      bestPrice: bestPrice,
      productCode: productCode,
      userCustomUvpPrice: userCustomUvpPrice,
      userCustomProfitMarginPercent: userCustomProfitMarginPercent,
      taxm1: taxm1
    };
    return this.http.post<SalesProductPrice>(
      this.occEndpoints.buildUrl('updateCustomSalesPrice', {queryParams: params}),
      params
    );
  }
}
